var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.796 2.8136L22.5 0L20.0847 9.81068L17.0716 6.9181L12.2112 11.981C12.0462 12.1528 11.8183 12.25 11.58 12.25C11.3417 12.25 11.1138 12.1528 10.9488 11.981L7.38 8.26348L2.13121 13.731C1.79655 14.0796 1.24265 14.0909 0.894036 13.7562C0.545426 13.4215 0.534122 12.8676 0.868787 12.519L6.74879 6.39403C6.91379 6.22216 7.14174 6.125 7.38 6.125C7.61826 6.125 7.84621 6.22216 8.01121 6.39403L11.58 10.1115L15.8091 5.70617L12.796 2.8136Z",
    fill: "#34C26D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRising);
export default __webpack_public_path__ + "static/media/rising.031686856cff27a0a846df66e3136631.svg";
export { ForwardRef as ReactComponent };